import { machineCNCData } from "@/pages/cms/cncDummy";
import { Box, Grid, Paper, Text } from "@mantine/core";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

interface CncState {
  startTime: string;
  elapsedTime: number; // 초
  runningTime: number; // 초
  stoppedTime: number; // 초
  efficiency: number;
  tool: number;
}

const formatTime = (seconds: number) => {
  const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const getEfficiency = (run: number, stop: number) => {
  const total = run + stop;
  if (total === 0) return 0;
  return Math.round((run / total) * 100);
};

export default function CncMonitoringPage() {
  const [dataList, setDataList] = useState<Record<string, CncState>>(() => {
    const baseTime = dayjs(); // 기준 시간
    const initState: Record<string, CncState> = {};

    machineCNCData.forEach((machine, index) => {
      const startTime = baseTime.add(index * 5, "second").format("HH:mm:ss");
      initState[machine.id] = {
        startTime,
        elapsedTime: 0,
        runningTime: 0,
        stoppedTime: 0,
        efficiency: 0,
        tool: 1,
      };
    });

    return initState;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setDataList((prev) => {
        const updated = { ...prev };

        machineCNCData.forEach((machine) => {
          const current = prev[machine.id];
          const isRunning = Math.random() < 0.95; // 95% 확률로 가동
          const runInc = isRunning ? 2 : 0;
          const stopInc = isRunning ? 0 : 2;

          const newRunningTime = current.runningTime + runInc;
          const newStoppedTime = current.stoppedTime + stopInc;
          const newElapsedTime = current.elapsedTime + 2;
          const newEfficiency = getEfficiency(newRunningTime, newStoppedTime);

          updated[machine.id] = {
            ...current,
            elapsedTime: newElapsedTime,
            runningTime: newRunningTime,
            stoppedTime: newStoppedTime,
            efficiency: newEfficiency,
          };
        });

        return updated;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {machineCNCData.map((machine) => (
        <Paper key={machine.id} withBorder p="md" radius="md" mb="md">
          <Box bg="blue.1" px="md" py="sm" mb="md">
            <Text fw={700} ta="center" size="xl">
              {machine.name}
            </Text>
          </Box>

          <Grid align="center">
            <Grid.Col span={4} style={{ textAlign: "center" }}>
              <Text fw={700}>가동률</Text>
              <Text size="xl" c="blue.9">
                {dataList[machine.id]?.efficiency}%
              </Text>
            </Grid.Col>

            <Grid.Col span={8}>
              <Grid>
                <Grid.Col span={6}>
                  <Text>시작 시간</Text>
                  <Text fw={700}>{dataList[machine.id]?.startTime}</Text>
                </Grid.Col>
                <Grid.Col span={6}>
                  <Text>가동 시간</Text>
                  <Text fw={700}>{formatTime(dataList[machine.id]?.runningTime || 0)}</Text>
                </Grid.Col>
                <Grid.Col span={6}>
                  <Text>경과 시간</Text>
                  <Text fw={700}>{formatTime(dataList[machine.id]?.elapsedTime || 0)}</Text>
                </Grid.Col>
                <Grid.Col span={6}>
                  <Text>비가동 시간</Text>
                  <Text fw={700}>{formatTime(dataList[machine.id]?.stoppedTime || 0)}</Text>
                </Grid.Col>
                <Grid.Col span={6}>
                  <Text>설비 효율</Text>
                  <Text fw={700}>{dataList[machine.id]?.efficiency}%</Text>
                </Grid.Col>
                <Grid.Col span={6}>
                  <Text>공구</Text>
                  <Text fw={700}>{dataList[machine.id]?.tool}</Text>
                </Grid.Col>
              </Grid>
            </Grid.Col>
          </Grid>
        </Paper>
      ))}
    </>
  );
}
